module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.iter-step.js
// module id = 334
// module chunks = 174 178 179 193 194 195